// Google Analytics counts a page view per route, the initial one included. The gtag stub is set up in
// gatsby-ssr.js, and only sends anything outside the consent countries listed there. That snippet's own
// config call has send_page_view off; this one is what sends each page_view, so the two config calls in
// dataLayer are one hit per page, not two.
export const onRouteUpdate = ({ location }) => {
  if (typeof window.gtag !== "function") return;
  window.gtag("config", "G-7KNWWS2F4H", {
    page_path: `${location.pathname}${location.search}${location.hash}`,
    anonymize_ip: true,
  });
};

// Where a click on the site leaves for the app or a store: app_click { destination, game, page, link_text }.
// One delegated listener covers every link, whatever page or component renders it. It only reports, and
// never navigates or cancels anything, so a page that holds its own link back (/try's demo_start) keeps
// control of that. Beacon transport lets the hit leave with the page. Subscription management links on
// the stores are not installs, so they are skipped.
const APP_DESTINATIONS = {
  "play.tvtop.games": "play",
  "apps.apple.com": "app_store",
  "play.google.com": "google_play",
  "channelstore.roku.com": "roku",
  "amazon.com": "amazon",
  "www.amazon.com": "amazon",
};
const NOT_AN_INSTALL = /^\/(account|store\/account)\//;
// Routes on play.tvtop.games that are not a game.
const NOT_A_GAME = ["", "games", "join", "link", "settings", "stats"];

const reportAppClick = (event) => {
  if (typeof window.gtag !== "function" || event.button > 1) return;
  const link = event.target instanceof Element ? event.target.closest("a[href]") : null;
  if (!link) return;
  let url;
  try {
    url = new URL(link.href);
  } catch (e) {
    return;
  }
  const destination = APP_DESTINATIONS[url.hostname];
  if (!destination || NOT_AN_INSTALL.test(url.pathname)) return;
  // On play.tvtop.games the first path segment is the game (with "demo" on a demo); the stores have none.
  const segment = url.pathname.split("/")[1] || "";
  const game =
    destination === "play" && !NOT_A_GAME.includes(segment)
      ? segment.replace(/demo$/, "")
      : undefined;
  window.gtag("event", "app_click", {
    destination,
    ...(game ? { game } : {}),
    page: window.location.pathname,
    link_text: (link.textContent || "").trim().replace(/\s+/g, " ").slice(0, 80),
    transport_type: "beacon",
  });
};

export const onClientEntry = () => {
  // Capture phase, so it runs before any handler can stop the click or leave the page. auxclick is the
  // middle button, which opens a new tab without a click event.
  document.addEventListener("click", reportAppClick, true);
  document.addEventListener("auxclick", reportAppClick, true);
};
